export default __webpack_public_path__ + "static/media/631.1fe2ab84.png";